import { STARTING_TAB } from '../constants/local-storage-enum';
const WHITELIST = [STARTING_TAB];

export const setItem = (key, value) => {
  /**
   * Mobile Safari (iOS 5+) always throws when user enters private mode
   * Safari sets the quota to 0 bytes in private mode, unlike other browsers, which allow storage in private mode using separate data containers.
   * Source: https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
   */
  try {
    if (WHITELIST.includes(key)) {
      window.localStorage.setItem(key, value);
      return true;
    }

    return false;
  } catch (err) {
    return false;
  }
};

export const getItem = key => {
  try {
    if (WHITELIST.includes(key)) {
      return window.localStorage.getItem(key);
    }

    return null;
  } catch (err) {
    return null;
  }
};

export const removeItem = key => {
  if (getItem(key)) {
    window.localStorage.removeItem(key);
    return true;
  }

  return false;
};
